import { UploadOutlined } from '@ant-design/icons';
import { Button, Form, notification, Upload } from 'antd';
import React from 'react';

interface FileUploadFormItemProps {
    required: boolean;
    label: string;
    name: string;
}

export const FileUploadFormItem = ({ required, label, name }: FileUploadFormItemProps) => (
    <Form.Item
        label={label}
        name={name}
        valuePropName="fileList"
        getValueFromEvent={(e) => e.fileList}
        rules={[
            {
                required: required,
                message: 'Пожалуйста, выберите файл',
            },
        ]}
    >
        <Upload
            beforeUpload={(file) => {
                const isXLSX =
                    file.type ===
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                if (!isXLSX) {
                    notification['warning']({
                        message: 'Формат загружаемого материала не соответствует параметрам!',
                        description: 'Файл должен иметь расширение: .xls, .xlsx',
                    });
                    return Upload.LIST_IGNORE;
                }

                return false;
            }}
            maxCount={1}
            accept=".xls,.xlsx"
        >
            <Button
                icon={<UploadOutlined />}
                color="blue"
            >
                Выберите файл
            </Button>
        </Upload>
    </Form.Item>
);
